import { useChat } from "@/features/chat"
import { ANALYTICS_EVENTS } from "@/features/analytics"
import { PersonalizedReports } from "@/features/today"

import {
  recommendedAdvisors,
  accurateAdvisors,
  bestInLoveAdvisors,
  topRatedAdvisors,
  sectionCopy,
} from "../config/sections"
import { advisorsList } from "../config/advisors"
import { useAdvisorActions } from "../hooks/use-advisor-actions"
import { usePreloadImages } from "../hooks/use-preload-images"

import { AllAdvisors } from "./all-advisors"
import { AdvisorCarouselSection } from "./advisor-carousel-section"
import { AdvisorOfTheDay } from "./advisor-of-the-day"
import { TapToAsk } from "./tap-to-ask"
import { AdvisorAds } from "./advisor-ads"
import { CreditsPurchaseModal } from "./credits-purchase-modal"

/** LPR4 advisors landing page — the webapp home tab. Ported from Advisors.tsx (V4 branch). */
export function AdvisorsPage() {
  usePreloadImages()
  const { userMainSubscriptionId } = useChat()
  const {
    isPaywallOpen,
    closePaywall,
    handleChatWithAdvisor,
    handleAdvisorInner,
    handleChatWithPreselectedQuestion,
  } = useAdvisorActions()

  return (
    <div className="-mx-4 flex flex-col bg-dark-base pb-10">
      <AllAdvisors onClick={handleAdvisorInner} />

      <AdvisorCarouselSection
        title={sectionCopy.recommended.title}
        subtitle={sectionCopy.recommended.subtitle}
        advisors={recommendedAdvisors}
        chatEvent={ANALYTICS_EVENTS.CHAT_WITH_RECOMMENDED_ADVISOR}
        onCardClick={handleAdvisorInner}
        onChatClick={handleChatWithAdvisor}
      />

      <PersonalizedReports />
      <div className="h-6" />

      <AdvisorCarouselSection
        title={sectionCopy.accurate.title}
        subtitle={sectionCopy.accurate.subtitle}
        advisors={accurateAdvisors}
        chatEvent={ANALYTICS_EVENTS.CHAT_WITH_MOST_ACCURATE_ADVISOR}
        onCardClick={handleAdvisorInner}
        onChatClick={handleChatWithAdvisor}
      />

      <AdvisorAds
        type="dream"
        advisor={advisorsList[11]}
        onChatClick={handleChatWithAdvisor}
        onPresetClick={(preset) => handleChatWithPreselectedQuestion(preset)}
      />

      <AdvisorCarouselSection
        title={sectionCopy.bestInLove.title}
        subtitle={sectionCopy.bestInLove.subtitle}
        advisors={bestInLoveAdvisors}
        chatEvent={ANALYTICS_EVENTS.CHAT_WITH_BEST_IN_LOVE_ADVISOR}
        onCardClick={handleAdvisorInner}
        onChatClick={handleChatWithAdvisor}
      />

      <AdvisorOfTheDay onClick={handleChatWithAdvisor} />

      <AdvisorCarouselSection
        title={sectionCopy.topRated.title}
        subtitle={sectionCopy.topRated.subtitle}
        advisors={topRatedAdvisors}
        chatEvent={ANALYTICS_EVENTS.CHAT_WITH_TOP_RATED_ADVISOR}
        onCardClick={handleAdvisorInner}
        onChatClick={handleChatWithAdvisor}
      />

      <TapToAsk onSelect={handleChatWithPreselectedQuestion} />

      <AdvisorAds
        type="moon"
        advisor={advisorsList[1]}
        onChatClick={handleChatWithAdvisor}
        onPresetClick={(preset) => handleChatWithPreselectedQuestion(preset)}
      />

      <CreditsPurchaseModal
        isOpen={isPaywallOpen}
        onClose={closePaywall}
        userMainSubscriptionId={userMainSubscriptionId}
        variant="main-page"
      />
    </div>
  )
}
